module.exports = __webpack_public_path__ + "img/full6-min.58450292.png";